export default "__VITE_ASSET__8jvLRNHN__"